// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ln-3";
export var downloadButton = "_ln-4";
export var fileContainer = "_ln-9 _ln-7";
export var fileContainerBase = "_ln-7";
export var fileContainerBaseSm = "_ln-a _ln-7";
export var fileContainerFixedHeight = "_ln-8 _ln-7";
export var fileContainerFixedHeightSm = "_ln-c _ln-a _ln-7";
export var fileContainerSm = "_ln-b _ln-a _ln-7";
export var fileInfo = "_ln-5";
export var fileInfoWidthRestricted = "_ln-6";
export var fileType = "_ln-1";
export var fileTypeName = "_ln-2";
export var fileTypeSm = "_ln-d _ln-1";
export var image = "_ln-0";
export var link = "_ln-f";
export var overflowEllipsis = "_ln-e";